// extracted by mini-css-extract-plugin
module.exports = {"message":"StockMessage_message__jUK_m"};